// import { useState, useEffect } from "react";
// import React from "react";
// import "./MenuTreeStructure.css";
// import MenuList from "./components/MenuList";
// import { useSelector } from "react-redux";

// const MenuTreeStructure = ({ setPagePath, setRoutes }) => {
//   // ==========================================
//   //  working
//   const [menuData, setMenuData] = useState([]);
//   // ==========================================

//   // const [isSidebarOpen, setIsSidebarOpen] = useState(true);

//   // const toggleSidebar = () => {
//   //   setIsSidebarOpen(!isSidebarOpen);
//   // };

//   // =======================
//   // working
//   const { data } = useSelector((state) => state.landing);

//   let menuDatas = data && data.client_schema_name?.[2];
//   let myFav = data && data.client_schema_name?.[5];
//   console.log("myFav", myFav)

//   useEffect(() => {
//     if (menuDatas) {
//       setMenuData(menuDatas);
//     }
//   }, [menuDatas]);

//   useEffect(() => {
//     const { localRoutes } = getMenuStructureWithColors(menuData);
//     setRoutes(localRoutes); // Assuming setRoutes is a prop function to update routes in parent
//   }, [menuData, setRoutes]);

//   const getMenuStructureWithColors = (data) => {
//     const menuMap = {};
//     const menuStructure = [];
//     let localRoutes = []; // Local variable to accumulate routes

//     data.forEach((menuItem) => {
//       if (!menuMap[menuItem.LVL1]) {
//         menuMap[menuItem.LVL1] = {
//           name: menuItem.LVL1,
//           colors: "#ecf0f1",
//           children: [],
//         };
//         menuStructure.push(menuMap[menuItem.LVL1]);
//       }

//       let level2 = menuMap[menuItem.LVL1].children.find(
//         (c) => c.name === menuItem.LVL2
//       );
//       if (!level2) {
//         level2 = {
//           name: menuItem.LVL2,
//           colors: "#bdc3c7",
//           children: [],
//         };
//         menuMap[menuItem.LVL1].children.push(level2);
//       }

//       let level3 = level2.children.find((c) => c.name === menuItem.LVL3);
//       if (!level3) {
//         level3 = {
//           name: menuItem.LVL3,
//           colors: "#95a5a6",
//         };
//         level2.children.push(level3);
//       }

//       if (menuItem.ui_path && menuItem.ui_element) {
//         // Check if the route already exists to prevent duplicates
//         const routeExists = localRoutes.some(
//           (route) =>
//             route.ui_path === menuItem.ui_path &&
//             route.ui_element === menuItem.ui_element
//         );
//         if (!routeExists) {
//           localRoutes.push({
//             ui_path: menuItem.ui_path,
//             ui_element: menuItem.ui_element,
//           });
//         }
//         // If LVL4 isn't needed, this ensures the UI path and element are only added where necessary
//         level3.ui_path = menuItem.ui_path;
//         level3.ui_element = menuItem.ui_element;
//       }
//     });

//     // Update routes state here after constructing the menu structure
//     // setRoutes(localRoutes);

//     return { menuStructure, localRoutes };
//   };
//   // ---------------------------------------------------------------------------------

//   // const menuStructure = getMenuStructure(menuData);
//   // const { menuStructure, localRoutes } = getMenuStructureWithColors(menuData);
//   const { menuStructure } = getMenuStructureWithColors(menuData);
//   console.log("menu",menuStructure)

//   return (
//     <div className="mn-container">
//       <MenuList
//         items={menuStructure}
//         setPagePath={setPagePath}
//         setRoutes={setRoutes}
//       />
//     </div>
//   );
// };

// export default MenuTreeStructure;

// ======================================================================================

// import { useState, useEffect } from "react";
// import React from "react";
// import "./MenuTreeStructure.css";
// import MenuList from "./components/MenuList";
// import { useSelector } from "react-redux";

// const MenuTreeStructure = ({ setPagePath, setRoutes }) => {
//   const [menuData, setMenuData] = useState([]);
//   const { data } = useSelector((state) => state.landing);

//   let menuDatas = data && data.client_schema_name?.[2];
//   let myFav = data && data.client_schema_name?.[5];
//   console.log("myFav", myFav);

//   useEffect(() => {
//     if (menuDatas) {
//       setMenuData(menuDatas);
//     }
//   }, [menuDatas]);

//   useEffect(() => {
//     const { localRoutes } = getMenuStructureWithColors(menuData);
//     setRoutes(localRoutes);
//   }, [menuData, setRoutes]);

//   const getMenuStructureWithColors = (data) => {
//     const menuMap = {};
//     const menuStructure = [];
//     let localRoutes = [];

//     data.forEach((menuItem) => {
//       if (!menuMap[menuItem.LVL1]) {
//         menuMap[menuItem.LVL1] = {
//           name: menuItem.LVL1,
//           colors: "#ecf0f1",
//           children: [],
//           my_fav: 0, // Initialize my_fav with 0
//         };
//         menuStructure.push(menuMap[menuItem.LVL1]);
//       }

//       let level2 = menuMap[menuItem.LVL1].children.find(
//         (c) => c.name === menuItem.LVL2
//       );
//       if (!level2) {
//         level2 = {
//           name: menuItem.LVL2,
//           colors: "#bdc3c7",
//           children: [],
//           my_fav: 0, // Initialize my_fav with 0
//         };
//         menuMap[menuItem.LVL1].children.push(level2);
//       }

//       let level3 = level2.children.find((c) => c.name === menuItem.LVL3);
//       if (!level3) {
//         level3 = {
//           name: menuItem.LVL3,
//           colors: "#95a5a6",
//           my_fav: 0, // Initialize my_fav with 0
//         };
//         level2.children.push(level3);
//       }

//       if (menuItem.ui_path && menuItem.ui_element) {
//         const routeExists = localRoutes.some(
//           (route) =>
//             route.ui_path === menuItem.ui_path &&
//             route.ui_element === menuItem.ui_element
//         );
//         if (!routeExists) {
//           localRoutes.push({
//             ui_path: menuItem.ui_path,
//             ui_element: menuItem.ui_element,
//           });
//         }
//         level3.ui_path = menuItem.ui_path;
//         level3.ui_element = menuItem.ui_element;

//         // Check if this menu item is in myFav
//         const isFav = myFav.some(
//           (fav) =>
//             fav.ui_path === menuItem.ui_path &&
//             fav.ui_element === menuItem.ui_element
//         );
//         level3.my_fav = isFav ? 1 : 0;
//       }
//     });

//     return { menuStructure, localRoutes };
//   };

//   const { menuStructure } = getMenuStructureWithColors(menuData);
//   console.log("menu",menuStructure)

//   return (
//     <div className="mn-container">
//       <MenuList
//         items={menuStructure}
//         setPagePath={setPagePath}
//         setRoutes={setRoutes}
//       />
//     </div>
//   );
// };

// export default MenuTreeStructure;

// ----------------------------------------------------------------------

// import { useState, useEffect } from "react";
// import React from "react";
// import "./MenuTreeStructure.css";
// import MenuList from "./components/MenuList";
// import { useSelector } from "react-redux";

// const MenuTreeStructure = ({ setPagePath, setRoutes }) => {
//   const [menuData, setMenuData] = useState([]);
//   const { data } = useSelector((state) => state.landing);

//   let menuDatas = data && data.client_schema_name?.[2];
//   let myFav = data && data.client_schema_name?.[5];
//   // console.log("myFav", myFav);

//   useEffect(() => {
//     if (menuDatas) {
//       setMenuData(menuDatas);
//     }
//   }, [menuDatas]);

//   useEffect(() => {
//     const { localRoutes } = getMenuStructureWithColors(menuData);
//     setRoutes(localRoutes);
//   }, [menuData, setRoutes]);

//   const getMenuStructureWithColors = (data) => {
//     const menuMap = {};
//     const menuStructure = [];
//     let localRoutes = [];

//     data.forEach((menuItem) => {
//       if (!menuMap[menuItem.LVL1]) {
//         menuMap[menuItem.LVL1] = {
//           name: menuItem.LVL1,
//           colors: "#ecf0f1",
//           children: [],
//           my_fav: 0, // Initialize my_fav with 0
//         };
//         menuStructure.push(menuMap[menuItem.LVL1]);
//       }

//       let level2 = menuMap[menuItem.LVL1].children.find(
//         (c) => c.name === menuItem.LVL2
//       );
//       if (!level2) {
//         level2 = {
//           name: menuItem.LVL2,
//           colors: "#bdc3c7",
//           children: [],
//           my_fav: 0, // Initialize my_fav with 0
//         };
//         menuMap[menuItem.LVL1].children.push(level2);
//       }

//       let level3 = level2.children.find((c) => c.name === menuItem.LVL3);
//       if (!level3) {
//         level3 = {
//           name: menuItem.LVL3,
//           colors: "#95a5a6",
//           my_fav: 0, // Initialize my_fav with 0
//         };
//         level2.children.push(level3);
//       }

//       if (menuItem.ui_path && menuItem.ui_element) {
//         const routeExists = localRoutes.some(
//           (route) =>
//             route.ui_path === menuItem.ui_path &&
//             route.ui_element === menuItem.ui_element
//         );
//         if (!routeExists) {
//           localRoutes.push({
//             ui_path: menuItem.ui_path,
//             ui_element: menuItem.ui_element,
//           });
//         }
//         level3.ui_path = menuItem.ui_path;
//         level3.ui_element = menuItem.ui_element;
//         level3.screen_id = menuItem.screen_id; // Add screen_id

//         // Check if this menu item is in myFav
//         const isFav = myFav.some(
//           (fav) =>
//             fav.ui_path === menuItem.ui_path &&
//             fav.ui_element === menuItem.ui_element
//         );
//         level3.my_fav = isFav ? 1 : 0;
//       }
//     });

//     return { menuStructure, localRoutes };
//   };

//   const { menuStructure } = getMenuStructureWithColors(menuData);
//   console.log("menu", menuStructure)

//   return (
//     <div className="mn-container">
//       <MenuList
//         items={menuStructure}
//         setPagePath={setPagePath}
//         setRoutes={setRoutes}
//       />
//     </div>
//   );
// };

// export default MenuTreeStructure;

// "my_fav": 1

// import { useState, useEffect } from "react";
// import React from "react";
// import "./MenuTreeStructure.css";
// import MenuList from "./components/MenuList";
// import { useSelector } from "react-redux";
// import Colors from "../../Constants/Colors";
// const MenuTreeStructure = ({ setPagePath, setRoutes }) => {
//   const [menuData, setMenuData] = useState([]);
//   const { data } = useSelector((state) => state.landing);

//   let menuDatas = data && data.client_schema_name?.[2];
//   let myFav = data && data.client_schema_name?.[5];

//   useEffect(() => {
//     if (menuDatas) {
//       setMenuData(menuDatas);
//     }
//   }, [menuDatas]);

//   useEffect(() => {
//     const { localRoutes } = getMenuStructureWithColors(menuData);
//     setRoutes(localRoutes);
//   }, [menuData, setRoutes]);

// const getMenuStructureWithColors = (data) => {
//   const menuMap = {};
//   const menuStructure = [];
//   let localRoutes = [];

//   data.forEach((menuItem) => {
//     // Check if LVL1 is not empty
//     if (menuItem.LVL1) {
//       if (!menuMap[menuItem.LVL1]) {
//         menuMap[menuItem.LVL1] = {
//           name: menuItem.LVL1,
//           colors: "#ecf0f1",
//           children: [],
//           my_fav: 0, // Initialize my_fav with 0
//         };
//         menuStructure.push(menuMap[menuItem.LVL1]);
//       }

//       // Check if LVL2 is not empty
//       if (menuItem.LVL2) {
//         let level2 = menuMap[menuItem.LVL1].children.find(
//           (c) => c.name === menuItem.LVL2
//         );
//         if (!level2) {
//           level2 = {
//             name: menuItem.LVL2,
//             colors: "#bdc3c7",
//             children: [],
//             my_fav: 0, // Initialize my_fav with 0
//           };
//           menuMap[menuItem.LVL1].children.push(level2);
//         }

//         // Check if LVL3 is not empty
//         if (menuItem.LVL3) {
//           let level3 = level2.children.find((c) => c.name === menuItem.LVL3);
//           if (!level3) {
//             level3 = {
//               name: menuItem.LVL3,
//               colors: "#95a5a6",
//               my_fav: 0, // Initialize my_fav with 0
//             };
//             level2.children.push(level3);
//           }

//           if (menuItem.ui_path && menuItem.ui_element) {
//             const routeExists = localRoutes.some(
//               (route) =>
//                 route.ui_path === menuItem.ui_path &&
//                 route.ui_element === menuItem.ui_element
//             );
//             if (!routeExists) {
//               localRoutes.push({
//                 ui_path: menuItem.ui_path,
//                 ui_element: menuItem.ui_element,
//               });
//             }
//             level3.ui_path = menuItem.ui_path;
//             level3.ui_element = menuItem.ui_element;
//             level3.screen_id = menuItem.screen_id; // Add screen_id

//             // Check if this menu item is in myFav
//             const isFav = myFav.some(
//               (fav) =>
//                 fav.ui_path === menuItem.ui_path &&
//                 fav.ui_element === menuItem.ui_element
//             );
//             level3.my_fav = isFav ? 1 : 0;
//           }
//         }
//       }
//     }
//   });

//   return { menuStructure, localRoutes };
// };


import { useState, useEffect } from "react";
import React from "react";
import "./MenuTreeStructure.css";
import MenuList from "./components/MenuList";
import { useSelector } from "react-redux";
import Colors from "../../Constants/Colors";
const MenuTreeStructure = ({ setPagePath, setRoutes }) => {
  const [menuData, setMenuData] = useState([]);
  const { data } = useSelector((state) => state.landing);

  let menuDatas = data && data.client_schema_name?.[2];
  let myFav = data && data.client_schema_name?.[5];

  useEffect(() => {
    if (menuDatas) {
      setMenuData(menuDatas);
    }
  }, [menuDatas]);

  useEffect(() => {
    const { localRoutes } = getMenuStructureWithColors(menuData);
    setRoutes(localRoutes);
  }, [menuData, setRoutes]);

  const getMenuStructureWithColors = (data) => {
    const menuMap = {};
    const menuStructure = [];
    let localRoutes = [];

    data.forEach((menuItem) => {
      // Check if LVL1 is not empty
      if (menuItem.LVL1) {
        if (!menuMap[menuItem.LVL1]) {
          menuMap[menuItem.LVL1] = {
            name: menuItem.LVL1,
            colors: `${Colors.color9}`,
            children: [],
            my_fav: 0, // Initialize my_fav with 0
          };
          menuStructure.push(menuMap[menuItem.LVL1]);
        }

        // Check if LVL2 is not empty
        if (menuItem.LVL2) {
          let level2 = menuMap[menuItem.LVL1].children.find(
            (c) => c.name === menuItem.LVL2
          );
          if (!level2) {
            level2 = {
              name: menuItem.LVL2,
              colors: `${Colors.color9}`,
              children: [],
              my_fav: 0, // Initialize my_fav with 0
            };
            menuMap[menuItem.LVL1].children.push(level2);
          }

          // Check if LVL3 is not empty
          if (menuItem.LVL3) {
            let level3 = level2.children.find((c) => c.name === menuItem.LVL3);
            if (!level3) {
              level3 = {
                name: menuItem.LVL3,
                colors: `${Colors.color9}`,
                my_fav: 0, // Initialize my_fav with 0
              };
              level2.children.push(level3);
            }

            if (menuItem.ui_path && menuItem.ui_element) {
              const routeExists = localRoutes.some(
                (route) =>
                  route.ui_path === menuItem.ui_path &&
                  route.ui_element === menuItem.ui_element
              );
              if (!routeExists) {
                localRoutes.push({
                  ui_path: menuItem.ui_path,
                  ui_element: menuItem.ui_element,
                });
              }
              level3.ui_path = menuItem.ui_path;
              level3.ui_element = menuItem.ui_element;
              level3.screen_id = menuItem.screen_id; // Add screen_id

              // Check if this menu item is in myFav
              const isFav = myFav.some(
                (fav) =>
                  fav.ui_path === menuItem.ui_path &&
                  fav.ui_element === menuItem.ui_element
              );
              level3.my_fav = isFav ? 1 : 0;
            }
          } else if (menuItem.ui_path && menuItem.ui_element) {
            // Handle case where there are no LVL3 children but LVL2 item should have ui_path and ui_element
            level2.ui_path = menuItem.ui_path;
            level2.ui_element = menuItem.ui_element;
            level2.screen_id = menuItem.screen_id; // Add screen_id

            const routeExists = localRoutes.some(
              (route) =>
                route.ui_path === menuItem.ui_path &&
                route.ui_element === menuItem.ui_element
            );
            if (!routeExists) {
              localRoutes.push({
                ui_path: menuItem.ui_path,
                ui_element: menuItem.ui_element,
              });
            }

            // Check if this menu item is in myFav
            const isFav = myFav.some(
              (fav) =>
                fav.ui_path === menuItem.ui_path &&
                fav.ui_element === menuItem.ui_element
            );
            level2.my_fav = isFav ? 1 : 0;
          }
        }
      }
    });

    return { menuStructure, localRoutes };
  };

  const { menuStructure } = getMenuStructureWithColors(menuData);

  return (
    <div className="mn-container">
      <MenuList
        items={menuStructure}
        setPagePath={setPagePath}
        setRoutes={setRoutes}
      />
    </div>
  );
};

export default MenuTreeStructure;
